import { render, staticRenderFns } from "./UiSpinnerLoading.vue?vue&type=template&id=e925e886&scoped=true"
import script from "./UiSpinnerLoading.vue?vue&type=script&lang=js"
export * from "./UiSpinnerLoading.vue?vue&type=script&lang=js"
import style0 from "./UiSpinnerLoading.vue?vue&type=style&index=0&id=e925e886&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e925e886",
  null
  
)

export default component.exports